import { useState } from 'react'

import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'

import type { Gebied } from '@models/Gebied'

import { SelectObject } from '../../../../core/components/SelectObject'
import { useSaveEvent } from '../../hooks/useSaveEvent'
import type { Project } from '../../types/Project'

interface Props {
  project: Project
  handleClose: () => void
  gebieden: Gebied[]
}

export const Gebiedswissel = ({ handleClose, project, gebieden }: Props) => {
  const { mutate: saveEvent, isPending } = useSaveEvent()
  const [gebied, setGebied] = useState<Gebied | null>(null)
  const [errors, setErrors] = useState({ gebiedError: false })

  const handleClick = () => {
    if (!gebied) {
      setErrors({ gebiedError: true })
      return
    }

    saveEvent(
      {
        id: project.aanvraagID,
        type: 'gebiedswissel',
        source: 'manual',
        data: {
          gebiedscode: gebied.code,
          sourceGebiedscode: project.gebiedscode,
        },
      },
      {
        onSuccess: () => handleClose(),
      },
    )
  }

  return (
    <>
      <DialogTitle>Wisselen van gebied</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Kies het gebied waar het project heen gewisseld moet worden. Na het
          opslaan zal het max 5 minuten duren voordat het project volledig
          gewisseld is
        </DialogContentText>
        <FormControl sx={{ width: '100%', p: 1 }}>
          <SelectObject
            options={gebieden}
            value={gebied}
            onChange={setGebied}
            getOptionLabel={(gebied) => `${gebied.code} - ${gebied.label}`}
            label="Doel gebied"
            error={errors['gebiedError']}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          Annuleren
        </Button>{' '}
        <Button
          disabled={isPending}
          onClick={() => handleClick()}
          color="primary"
        >
          Opslaan
        </Button>
      </DialogActions>
    </>
  )
}
